module.exports = __webpack_public_path__ + "img/1.cc2f7468.jpg";